import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Contact } from '../interfaces/contact';
import { environment } from '../../environments/environment';
import { HtmlService } from './htmlservice';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private baseUrl = environment.baseUrl;
  private urlGetAll = this.baseUrl + "/api/Contact/getall";
  private urlPersist = this.baseUrl + "/api/Contact";

  constructor(private http: HttpClient, private htmlService: HtmlService) { }

  getAllContacts(): Observable<any[]>{

    const headers = this.htmlService.getHeaders();
    const result = this.http.get<any[]>(this.urlGetAll, {headers});
    return result;
  }

  addContact(contact: Contact): Observable<any[]>{
    const headers = this.htmlService.getHeaders();
    const result = this.http.post<any[]>(this.urlPersist, contact, {headers});
    return result;
  }

  updateContact(contact: Contact): Observable<any[]>{
    const headers = this.htmlService.getHeaders();
    let result = this.http.patch<any[]>(`${this.urlPersist}/${contact.id}`, contact, {headers});
    return result;
  }

  deleteContact(id: string): Observable<any[]>{
    const headers = this.htmlService.getHeaders();
    let result = this.http.delete<any[]>(`${this.urlPersist}/${id}`, {headers});
    return result;
  }
}
